export default class FixedClock {

    //returns actual UTC time; when first invoked we calculate the system clock's offset from NTP, then use that in future
    //if setClockDrift hasn't been called, we'll assume 0. 
    static utc() {
        if (!this.clock_drift) {
            // console.log("WARNING: Clock drift has not been calculated. Assuming 0.");
            return Date.now();
        } else {
            let val = Date.now() + this.clock_drift;
            return val;
        }
    }

    //this.clock_drift=1000 means our clock is 1000 millis ahead of the "real" time.
    static async setClockDrift() {
        // NTP requires UDP, which we don't have from a browser.
        // http://worldtimeapi.org/api/timezone/Etc/UTC.json
        let response = await fetch("https://worldtimeapi.org/api/timezone/Etc/UTC.json");
        let data = await response.json();
        let actualTime = data.unixtime * 1000; //we only have 1s precision from this api
        this.clock_drift = actualTime - Date.now();
        // console.log("Setting clock drift to ", this.clock_drift);
    }

}

